var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.Title,"visible":_vm.YenilikModal,"center":"","width":"50%"}},[_c('a',{staticClass:"ModalKapat",on:{"click":function($event){return _vm.$emit('YenilikModal', false)}}},[_c('i',{staticClass:"el-icon-close"})]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.Data[0].Icerik)}}),_vm._v(" "),_c('Yukleniyor',{attrs:{"data":_vm.lo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5ec901a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pack/Genel/Yenilikler.vue
// module id = 503
// module chunks = 0